import React from 'react';
import { useAuth } from './AuthContext';
import LoginPage from './LoginPage';
import DashboardPage from './DashboardPage';

const Home: React.FC = () => {
    const { isLoggedIn } = useAuth();  // 使用来自 AuthContext 的 isLoggedIn

    return isLoggedIn ? <DashboardPage /> : <LoginPage />;
};

export default Home;

